import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    // url: "http://20.126.131.185:8080/realms/master/protocol/openid-connect/auth?client_id=pos_client_id&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fapp%2Fpanden&scope=openid&response_type=token&response_mode=form_post&state=ba21ylopoxp&nonce=mzgii58u9gb"
    url: "https://keycloaktest.ig-nl.com:8443/",
    realm: "master",
    clientId: "pos_client_id"
});

export default keycloak;